import { render, staticRenderFns } from "./ClickTracker.vue?vue&type=template&id=22076508&scoped=true"
import script from "./ClickTracker.vue?vue&type=script&lang=js"
export * from "./ClickTracker.vue?vue&type=script&lang=js"
import style0 from "./ClickTracker.vue?vue&type=style&index=0&id=22076508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22076508",
  null
  
)

export default component.exports